import Skeleton from "react-loading-skeleton";
import { Heading } from "@/components/catalyst/Heading";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/catalyst/Table";

export function EarningsSkeleton() {
	return (
		<div>
			<div className="flex items-center justify-between">
				<Heading level={2}>Partner Earnings</Heading>
			</div>

			<Table className="mt-8">
				<TableHead>
					<TableRow>
						<TableHeader>App</TableHeader>
						<TableHeader>Partner</TableHeader>
						<TableHeader>Amount</TableHeader>
						<TableHeader>Status</TableHeader>
						<TableHeader>Transaction</TableHeader>
						<TableHeader>Created</TableHeader>
					</TableRow>
				</TableHead>
				<TableBody>
					{Array.from({ length: 5 }).map((_, i) => (
						<TableRow key={i}>
							<TableCell>
								<Skeleton width={100} />
							</TableCell>
							<TableCell>
								<Skeleton width={120} />
							</TableCell>
							<TableCell>
								<Skeleton width={80} />
							</TableCell>
							<TableCell>
								<Skeleton width={70} borderRadius={9999} />
							</TableCell>
							<TableCell>
								<Skeleton width={100} />
							</TableCell>
							<TableCell>
								<Skeleton width={90} />
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
}
